export default function VideoController() {

}